import { useTema, type Tema } from '../lib/tema'

const SIGUIENTE: Record<Tema, Tema> = {
  sistema: 'claro',
  claro: 'oscuro',
  oscuro: 'sistema',
}

const TITULO: Record<Tema, string> = {
  sistema: 'Como el sistema',
  claro: 'Modo claro',
  oscuro: 'Modo oscuro',
}

/**
 * La lunita. Tres posiciones: como el sistema, claro y oscuro, en ese orden.
 *
 * Es lo que pidió José: él prefiere el claro, pero que se pueda cambiar. El
 * icono dice en qué posición está, no a dónde va, que es lo que la gente espera.
 */
export function BotonTema() {
  const { tema, cambiar } = useTema()

  return (
    <button
      onClick={() => cambiar(SIGUIENTE[tema])}
      title={`${TITULO[tema]}. Pulsa para pasar a: ${TITULO[SIGUIENTE[tema]].toLowerCase()}`}
      aria-label={TITULO[tema]}
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-200
                 text-slate-500 transition hover:border-marca-500 hover:text-marca-700
                 dark:border-slate-700 dark:hover:text-marca-100"
    >
      <span aria-hidden className="text-sm leading-none">
        {tema === 'claro' ? '☀' : tema === 'oscuro' ? '☾' : '◐'}
      </span>
    </button>
  )
}
